import React, { useState } from "react";
import { Grid, Skeleton } from "@mui/material";

const BASE_URL = "https://www.enermatch.com/loja-enermatch-app"

export const Store = ({ location }) => {
  const [isLoading, setIsLoading] = useState(true);

  const src = location.state?.customUrl || BASE_URL;

  return (
    <Grid
      container
      item
      direction="column"
      alignItems="center"
      sx={{ flex: 1 }}
    >
      {isLoading && (
        <Skeleton
          variant="rectangular"
          width="60%"
          height="25%"
          sx={{ position: "absolute", top: "35%" }}
        />
      )}

      <iframe
        src={src}
        onLoad={() => setIsLoading(false)}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        title="Loja Virtual da Enermatch"
      />
    </Grid>
  );
};